export default {
  types: [{
      text: '短信通知',
      value: 'notification'
    },
    {
      text: '验证码',
      value: 'code'
    },
    {
      text: '推广广告',
      value: 'marketing'
    }
  ],
  usages: [{
      text: '密码找回',
      value: 'password_reset'
    },
    {
      text: '绑定手机号码',
      value: 'mobile_binding'
    },
    {
      text: '用户注册',
      value: 'user_register'
    },
    {
      text: '消息通知',
      value: 'notice_notification'
    }
  ],
  signatures: [{
    text: '景德镇窑厂',
    value: '景德镇语窑厂'
  }]
}


// WEBPACK FOOTER //
// ./src/store/config/sms.js